import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "tr", setLang: () => {}, t: {} });

export const T = {
  tr: {
    nav: {
      nedir: "Shake & Shake Nedir?",
      receteler: "Fonksiyonel Reçeteler",
      donanim: "Teknik Özellikler",
      neden: "Neden Shake & Shake?",
      isbirligi: "İşbirliği",
      iletisim: "İletişim",
      menu: "Menü",
    },
    hero: { counter: "Hazırlanıyor", hint: "Kaydır — shake'in dolsun" },
    marquee: [
      "25 Saniyede Taze Hazırlık",
      "24/7 Biyolojik Destek",
      "Sıfır Operasyonel Yük",
      "Tam Kişiselleştirme",
      "Temassız Ödeme",
      "Auto-Clean Sterilizasyon",
      "Premium Gym Standardı",
    ],
    manifesto: {
      label: "Manifesto",
      title: "Shake & Shake Nedir?",
      a: "Shake & Shake; antrenman öncesi odaktan, seans içi hidrasyona, kas gelişiminden gece uykusuna kadar vücudunuzun ihtiyaç duyduğu tüm biyolojik desteği ",
      hi: "sadece 25 saniyede",
      b: ", taze ve mükemmel kıvamda sunan Fonksiyonel Beslenme & Biohacking Hub'ıdır.",
    },
    recipes: {
      label: "Formülasyonlar",
      title: "Fonksiyonel Reçeteler",
      sub: "Günün 24 saati boyunca alınması gereken tüm biyolojik ve makro takviyeleri tek bir hub'da topluyoruz.",
      macrosTitle: "Makrolar & Temel İçerikler",
      functionalTitle: "Fonksiyonel Destekler",
      macros: ["Whey Protein", "Vegan Protein", "EAA (9 Esansiyel Amino Asit)", "Kreatin Monohidrat", "Karbonhidrat (Glikojen)", "Gliserol"],
      functional: ["Magnezyum Glisinat", "Kolajen Peptit", "Pancar Nitratı", "Tart Cherry", "Prebiyotik (PHGG)", "ZMA", "L-Teanin", "Apigenin", "Kafein", "Tirozin", "C Vitamini", "Zencefil", "Wheatgrass"],
      h1: "Her alan için benzersiz reçeteler!",
      b1: "Reçeteleri, salonunuzun üye profiline ve konseptine özel tasarlıyoruz.",
      h2: "Kişiselleştirilebilir reçeteler!",
      b2: "Üye makro ve takviye dozunu seçer; hedefi ve o anki ihtiyacı için kişiselleştirilmiş Shake & Shake'ini yaratır.",
    },
    hardware: {
      label: "Endüstriyel Tasarım",
      title: "Donanım & Altyapı",
      sub: "Ayna krom gövde, lavender neon aydınlatma ve tam otonom iç mimari. Salonunuza prestij katan bir tasarım ikonu.",
      specsTitle: "Teknik Özellikler",
      alt: "Shake & Shake otomatı",
      hotspots: {
        screen: { title: "32” Akıllı HD Dokunmatik Ekran", desc: "Kullanıcı dostu, sezgisel ve hızlı arayüz." },
        payment: { title: "100% Temassız Ödeme", desc: "QR kod, Kredi Kartı ve Mobil Ödeme entegrasyonu." },
        dosing: { title: "Yüksek Kapasite & Hassas Dozajlama", desc: "Çoklu toz ve sıvı tankları ile gramaj sapmasız, topaklanmasız taze karıştırma." },
        clean: { title: "Auto-Clean Teknolojisi", desc: "Her içecekten sonra yüksek sıcaklık ve su ile kapalı devre otomatik sterilizasyon." },
      },
      specs: [
        ["Ekran", "32” Akıllı HD Dokunmatik Ekran"],
        ["Derinlik", "900 mm"],
        ["Yükseklik", "1950 mm"],
        ["Genişlik", "1100 mm"],
        ["Ağırlık", "400 kg"],
        ["Güç", "AC 220–240V / 50Hz (Standart Ev/Ofis Prizi)"],
      ],
      compact: {
        title: "Kompakt Model",
        alt: "Shake & Shake Kompakt otomat",
        hotspots: {
          screen: { title: "18” Akıllı HD Dokunmatik Ekran", desc: "Kullanıcı dostu, sezgisel ve hızlı bir arayüz." },
          payment: { title: "%100 Temassız Ödeme", desc: "" },
          dosing: { title: "Yüksek Kapasite & Hassas Dozajlama", desc: "" },
          clean: { title: "Auto-Clean Teknolojisi", desc: "" },
        },
        specs: [
          ["Ekran", "18” Akıllı HD Dokunmatik Ekran"],
          ["Derinlik", "580 mm"],
          ["Yükseklik", "520 mm"],
          ["Genişlik", "700 mm"],
          ["Ağırlık", "43 kg"],
          ["Güç", "1800 W (Standart Ev/Ofis Prizi)"],
        ],
      },
    },
    value: {
      label: "Fayda Dengesi",
      title: "Neden Shake & Shake?",
      sub: "Kullanmadığınız 1 metrekareyi, salonunuzun en prestijli noktasına dönüştürün.",
      groups: [
        { title: "Üye Sadakati", desc: "Üyelerin salondan çıkmadan tüm takviye ve beslenme ihtiyaçlarını karşılamasını sağlayarak bağlılığı artırın." },
        { title: "Prestij & Farklılaşma", desc: "Salonunuzda Biohacking & Beslenme Hub'ı konseptini sunun." },
        { title: "Sıfır Operasyonel Yük", desc: "Stok takibi, dolum, temizlik, hijyen ve teknik bakım tamamen Shake & Shake ekibindedir." },
      ],
    },
    comparison: {
      label: "İş Birliği Modeli",
      title: "Nasıl Çalışıyoruz?",
      sub: "Karmaşık süreçler yok. Siz yalnızca alanı gösterin, gerisini biz halledelim.",
      weBadge: "Bizim Sorumluluğumuz",
      weTitle: "Biz Ne Sağlıyoruz?",
      we: ["Ücretsiz cihaz kurulumu", "Stok takibi", "7/24 teknik servis", "Salona özel etkinlik sponsorlukları", "Ortak pazarlama desteği"],
      youBadge: "Sizin Alanınız",
      youTitle: "Sizden Ne Bekliyoruz?",
      you: ["Salonunuzda sadece 1 metrekarelik göz önünde bir alan", "Standart bir elektrik prizi"],
      note: "Hepsi bu. Kurulumdan sonrası tamamen bizde.",
    },
    form: {
      label: "İletişim",
      title: "Talep Oluştur",
      a: "Salonunuzu sadece spor yapılan bir alan olmaktan çıkarıp, bütünsel bir ",
      hi: "“Fonksiyonel Yaşam & Performans Merkezi”",
      b: "ne dönüştürelim. Daha fazla bilgi için bizimle iletişime geçin!",
      fields: {
        full_name: { label: "Ad / Soyad", ph: "Ahmet Yılmaz" },
        gym_name: { label: "Salon Adı", ph: "Titanium Fitness Club" },
        city: { label: "Şehir / İlçe", ph: "İstanbul / Etiler" },
        phone: { label: "Telefon", ph: "+90 (555) 000 00 00" },
        email: { label: "E-posta", ph: "ahmet@salon.com" },
      },
      submit: "Talep Oluştur",
      sending: "Gönderiliyor...",
      success: "Talebiniz alındı! Ekibimiz 24 saat içinde sizinle iletişime geçecek.",
      error: "Talep gönderilemedi. Lütfen bilgilerinizi kontrol edip tekrar deneyin.",
    },
    footer: {
      company: "Şirket Bilgileri",
      privacy: "Kişisel Verilerin Korunması",
      copyright: "Tüm hakları saklıdır © 2026 Shake & Shake — Fonksiyonel Beslenme & Biohacking Hub",
    },
    legal: { home: "Ana Sayfa" },
    company: {
      title: "Şirket Bilgileri",
      intro: "shakeandshake.com aşağıdaki şirket tarafından sunulmaktadır:",
      address: "Adres: Sachsenhäuser Landwehrweg 159A, 60599, Frankfurt, Almanya",
      emailLabel: "E-posta:",
      boardTitle: "Yönetim Kurulu",
      board: ["Esma Kaya", "Yağmur Yüksel"],
      bankTitle: "Banka Bilgileri",
      bank: ["Lussho GmbH", "IBAN: DE07100101230684488872", "BIC: QNTODEB2XXX"],
      regTitle: "Ticaret Sicili",
      reg: ["Kayıtlı Olduğu Mahkeme: Frankfurt Ticaret Mahkemesi", "Ticaret Sicil Numarası: HRB 136122", "Vergi Numarası: 014 238 30217"],
      legalTitle: "Hukuki Uyarılar",
      legal1: "Avrupa Komisyonu'nun Online Uyuşmazlık Çözüm Platformu'na (OS-Plattform) erişim bağlantısı:",
      odr: "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage",
      legal2: "(Tüketici uyuşmazlıklarının çevrimiçi çözümüne ilişkin düzenlemeye uygun olarak paylaşılmıştır.)",
      legal3: "Bir tüketici tahkim prosedürüne katılmakla yükümlü değiliz ve bu konuda bir taahhütümüz bulunmamaktadır.",
    },
    kvkk: {
      title: "Kişisel Verilerin Korunması",
      updated: "shakeandshake.com — son güncelleme: 5 Eylül 2026",
      blocks: [
        {
          title: "Veri sorumlusu",
          paras: [
            "Bu internet sitesi Lussho GmbH tarafından işletilir. Adres: Sachsenhäuser Landwehrweg 159A, 60599 Frankfurt, Almanya E-posta: info@shakeandshake.com",
            "Veri koruma sorularınız için aynı adresi kullanın. Zorunlu bir veri koruma görevlimiz (DPO) atanmamıştır; atandığı takdirde bu sayfada yayınlanır.",
          ],
        },
        {
          title: "Bu metnin kapsamı",
          paras: ["Metin, shakeandshake.com ziyareti, iletişim formu ve B2B / demo talepleri sırasında işlenen kişisel veriler içindir. Makine başındaki ödeme ve üye shake profilleri salon işletmecisinin kendi sürecidir; o veri akışı ayrı sözleşmeyle düzenlenir."],
        },
        {
          title: "Hangi veriler",
          list: [
            "İletişim formunda verdiğiniz ad, soyad, şirket, e-posta, telefon, mesaj",
            "Sunucu kayıtları: IP, tarayıcı, tarih/saat, istenen sayfa",
            "Çerezler: yalnızca sitenin çalışması için zorunlu olanlar (oturum). Pazarlama veya analitik çerezi kullanırsak bu bölüm güncellenir.",
            "Sosyal medya: Instagram vb. bağlantıya tıklarsanız ilgili platformun kendi politikası geçer.",
          ],
        },
        {
          title: "Amaç ve hukuki dayanak (GDPR md. 6)",
          list: [
            "Siteyi sunmak ve güvenliği sağlamak — meşru menfaat",
            "Demo / işbirliği talebine cevap — sözleşme öncesi adımlar veya meşru menfaat",
            "Yasal yükümlülük (muhasebe, resmi talep)",
            "Pazarlama e-postası yalnızca açık rızanızla",
          ],
        },
        {
          title: "Saklama",
          list: [
            "İletişim talepleri: işlem bitene ve makul takip süresine kadar, kural olarak en fazla 24 ay",
            "Fatura / ticari yazışma: Alman ticaret ve vergi süreleri (kural olarak 6–10 yıl)",
            "Sunucu logları: kısa süre, güvenlik için gerekli olduğu kadar",
          ],
        },
        {
          title: "Aktarım",
          paras: ["Veri, talebi yanıtlamak ve siteyi barındırmak için hizmet sağlayıcılara (hosting, e-posta) aktarılabilir. ABD veya AEA dışı aktarım varsa uygun güvence kullanılır. Resmi mercilere yasal zorunluluk halinde iletilir. Veriyi satmayız."],
        },
        {
          title: "Haklarınız (GDPR md. 15–21)",
          paras: ["Erişim, düzeltme, silme, işlemeyi kısıtlama, taşınabilirlik, itiraz, rızayı geri çekme. Başvuru: info@shakeandshake.com Şikayet: Hessischer Beauftragte für Datenschutz und Informationsfreiheit (HBDI), Almanya. Türkiye'de ikamet ediyorsanız Kişisel Verileri Koruma Kurumu'na da başvurabilirsiniz."],
        },
        {
          title: "Çerezler",
          paras: ["Zorunlu çerezler siteyi çalıştırır. İsteğe bağlı çerez eklersek rıza banner'ı kullanılır."],
        },
        {
          title: "Güvenlik",
          paras: ["HTTPS ve ihtiyaca uygun teknik/idari tedbirler uygulanır. Mutlak güvenlik taahhüdü verilmez."],
        },
        {
          title: "Değişiklik",
          paras: ["Metin güncellenebilir. Yürürlük tarihi sayfanın üzerindedir."],
        },
      ],
    },
  },
  en: {
    nav: {
      nedir: "What is Shake & Shake?",
      receteler: "Functional Recipes",
      donanim: "Technical Specs",
      neden: "Why Shake & Shake?",
      isbirligi: "Partnership",
      iletisim: "Contact",
      menu: "Menu",
    },
    hero: { counter: "Preparing", hint: "Scroll — let your shake fill" },
    marquee: [
      "Fresh in 25 Seconds",
      "24/7 Biological Support",
      "Zero Operational Burden",
      "Full Personalization",
      "Contactless Payment",
      "Auto-Clean Sterilization",
      "Premium Gym Standard",
    ],
    manifesto: {
      label: "Manifesto",
      title: "What is Shake & Shake?",
      a: "Shake & Shake is a Functional Nutrition & Biohacking Hub that delivers all the biological support your body needs — from pre-workout focus, to intra-session hydration, to muscle growth and night-time sleep — ",
      hi: "in just 25 seconds",
      b: ", fresh and with perfect consistency.",
    },
    recipes: {
      label: "Formulations",
      title: "Functional Recipes",
      sub: "We gather all the biological and macro supplements your body needs around the clock in a single hub.",
      macrosTitle: "Macros & Core Ingredients",
      functionalTitle: "Functional Boosters",
      macros: ["Whey Protein", "Vegan Protein", "EAA (9 Essential Amino Acids)", "Creatine Monohydrate", "Carbohydrate (Glycogen)", "Glycerol"],
      functional: ["Magnesium Glycinate", "Collagen Peptides", "Beetroot Nitrate", "Tart Cherry", "Prebiotic (PHGG)", "ZMA", "L-Theanine", "Apigenin", "Caffeine", "Tyrosine", "Vitamin C", "Ginger", "Wheatgrass"],
      h1: "Unique recipes for every space!",
      b1: "We design recipes tailored to your gym's member profile and concept.",
      h2: "Customizable recipes!",
      b2: "Members choose their own macro and supplement doses — creating a Shake & Shake personalized to their goals and their needs in the moment.",
    },
    hardware: {
      label: "Industrial Design",
      title: "Hardware & Infrastructure",
      sub: "Mirror-chrome body, lavender neon lighting and fully autonomous interior architecture. A design icon that adds prestige to your gym.",
      specsTitle: "Technical Specifications",
      alt: "Shake & Shake machine",
      hotspots: {
        screen: { title: "32” Smart HD Touchscreen", desc: "A user-friendly, intuitive and fast interface." },
        payment: { title: "100% Contactless Payment", desc: "QR code, credit card and mobile payment integration." },
        dosing: { title: "High Capacity & Precise Dosing", desc: "Multiple powder and liquid tanks for fresh, lump-free mixing with zero gram deviation." },
        clean: { title: "Auto-Clean Technology", desc: "Closed-circuit automatic sterilization with high-temperature water after every drink." },
      },
      specs: [
        ["Screen", "32” Smart HD Touchscreen"],
        ["Depth", "900 mm"],
        ["Height", "1950 mm"],
        ["Width", "1100 mm"],
        ["Weight", "400 kg"],
        ["Power", "AC 220–240V / 50Hz (Standard Home/Office Outlet)"],
      ],
      compact: {
        title: "Compact Model",
        alt: "Shake & Shake compact machine",
        hotspots: {
          screen: { title: "18” Smart HD Touchscreen", desc: "A user-friendly, intuitive and fast interface." },
          payment: { title: "100% Contactless Payment", desc: "" },
          dosing: { title: "High Capacity & Precise Dosing", desc: "" },
          clean: { title: "Auto-Clean Technology", desc: "" },
        },
        specs: [
          ["Screen", "18” Smart HD Touchscreen"],
          ["Depth", "580 mm"],
          ["Height", "520 mm"],
          ["Width", "700 mm"],
          ["Weight", "43 kg"],
          ["Power", "1800 W (Standard Home/Office Outlet)"],
        ],
      },
    },
    value: {
      label: "Value Balance",
      title: "Why Shake & Shake?",
      sub: "Turn your unused 1 square meter into the most prestigious spot in your gym.",
      groups: [
        { title: "Member Loyalty", desc: "Increase retention by letting members cover all their supplement and nutrition needs without leaving the gym." },
        { title: "Prestige & Differentiation", desc: "Offer the Biohacking & Nutrition Hub concept in your gym." },
        { title: "Zero Operational Burden", desc: "Stock tracking, refilling, cleaning, hygiene and technical maintenance are entirely handled by the Shake & Shake team." },
      ],
    },
    comparison: {
      label: "Partnership Model",
      title: "How We Work",
      sub: "No complex processes. You just show us the space, we handle the rest.",
      weBadge: "Our Responsibility",
      weTitle: "What We Provide",
      we: ["Free machine installation", "Stock tracking", "24/7 technical service", "Gym-specific event sponsorships", "Joint marketing support"],
      youBadge: "Your Part",
      youTitle: "What We Expect From You",
      you: ["Just 1 square meter of visible space in your gym", "A standard power outlet"],
      note: "That's all. Everything after installation is entirely on us.",
    },
    form: {
      label: "Contact",
      title: "Submit a Request",
      a: "Let's turn your gym from a place people simply work out into a holistic ",
      hi: "“Functional Living & Performance Center”",
      b: ". Contact us for more information!",
      fields: {
        full_name: { label: "Full Name", ph: "John Smith" },
        gym_name: { label: "Gym Name", ph: "Titanium Fitness Club" },
        city: { label: "City / District", ph: "Munich / Bogenhausen" },
        phone: { label: "Phone", ph: "+49 170 000 00 00" },
        email: { label: "Email", ph: "john@gym.com" },
      },
      submit: "Submit Request",
      sending: "Sending...",
      success: "Your request has been received! Our team will contact you within 24 hours.",
      error: "Your request could not be sent. Please check your details and try again.",
    },
    footer: {
      company: "Company Information",
      privacy: "Privacy Notice",
      copyright: "All rights reserved © 2026 Shake & Shake — Functional Nutrition & Biohacking Hub",
    },
    legal: { home: "Home" },
    company: {
      title: "Company Information",
      intro: "shakeandshake.com is provided by the following company:",
      address: "Address: Sachsenhäuser Landwehrweg 159A, 60599, Frankfurt, Germany",
      emailLabel: "Email:",
      boardTitle: "Board of Directors",
      board: ["Esma Kaya", "Yağmur Yüksel"],
      bankTitle: "Bank Details",
      bank: ["Lussho GmbH", "IBAN: DE07100101230684488872", "BIC: QNTODEB2XXX"],
      regTitle: "Commercial Register",
      reg: ["Court of Registration: Frankfurt Commercial Court", "Commercial Register Number: HRB 136122", "Tax Number: 014 238 30217"],
      legalTitle: "Legal Notices",
      legal1: "Access link to the European Commission's Online Dispute Resolution platform (OS-Plattform):",
      odr: "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage",
      legal2: "(Shared in accordance with the regulation on the online resolution of consumer disputes.)",
      legal3: "We are not obliged to participate in a consumer arbitration procedure and make no commitment to do so.",
    },
    kvkk: {
      title: "Privacy Notice",
      updated: "shakeandshake.com — last updated: 5 September 2026",
      blocks: [
        {
          title: "Data controller",
          paras: [
            "This website is operated by Lussho GmbH. Address: Sachsenhäuser Landwehrweg 159A, 60599 Frankfurt, Germany Email: info@shakeandshake.com",
            "Please use the same address for data protection questions. No mandatory data protection officer (DPO) has been appointed; should one be appointed, it will be published on this page.",
          ],
        },
        {
          title: "Scope of this notice",
          paras: ["This text covers personal data processed during visits to shakeandshake.com, the contact form and B2B / demo requests. Payment at the machine and member shake profiles are the gym operator's own process; that data flow is governed by a separate agreement."],
        },
        {
          title: "Which data",
          list: [
            "Name, surname, company, email, phone and message you provide in the contact form",
            "Server logs: IP address, browser, date/time, requested page",
            "Cookies: only those strictly necessary for the site to function (session). If we use marketing or analytics cookies, this section will be updated.",
            "Social media: if you click a link such as Instagram, the respective platform's own policy applies.",
          ],
        },
        {
          title: "Purpose and legal basis (GDPR Art. 6)",
          list: [
            "Providing the site and ensuring security — legitimate interest",
            "Responding to a demo / partnership request — pre-contractual steps or legitimate interest",
            "Legal obligations (accounting, official requests)",
            "Marketing emails only with your explicit consent",
          ],
        },
        {
          title: "Retention",
          list: [
            "Contact requests: until processed and a reasonable follow-up period, as a rule no longer than 24 months",
            "Invoices / business correspondence: German commercial and tax retention periods (as a rule 6–10 years)",
            "Server logs: short term, only as long as required for security",
          ],
        },
        {
          title: "Transfer",
          paras: ["Data may be transferred to service providers (hosting, email) in order to respond to requests and to host the site. Where data is transferred to the US or outside the EEA, appropriate safeguards are used. Data is disclosed to authorities only where legally required. We do not sell data."],
        },
        {
          title: "Your rights (GDPR Art. 15–21)",
          paras: ["Access, rectification, erasure, restriction of processing, portability, objection, withdrawal of consent. Contact: info@shakeandshake.com Complaints: Hessischer Beauftragte für Datenschutz und Informationsfreiheit (HBDI), Germany. If you reside in Türkiye, you may also apply to the Turkish Personal Data Protection Authority (KVKK)."],
        },
        {
          title: "Cookies",
          paras: ["Strictly necessary cookies keep the site running. If we add optional cookies, a consent banner will be used."],
        },
        {
          title: "Security",
          paras: ["HTTPS and appropriate technical and organisational measures are applied. Absolute security is not guaranteed."],
        },
        {
          title: "Changes",
          paras: ["This text may be updated. The effective date is at the top of the page."],
        },
      ],
    },
  },
  de: {
    nav: {
      nedir: "Was ist Shake & Shake?",
      receteler: "Funktionelle Rezepte",
      donanim: "Technische Daten",
      neden: "Warum Shake & Shake?",
      isbirligi: "Zusammenarbeit",
      iletisim: "Kontakt",
      menu: "Menü",
    },
    hero: { counter: "Wird zubereitet", hint: "Scrollen — dein Shake füllt sich" },
    marquee: [
      "Frisch in 25 Sekunden",
      "24/7 Biologische Unterstützung",
      "Null Betriebsaufwand",
      "Volle Personalisierung",
      "Kontaktloses Bezahlen",
      "Auto-Clean-Sterilisation",
      "Premium-Gym-Standard",
    ],
    manifesto: {
      label: "Manifest",
      title: "Was ist Shake & Shake?",
      a: "Shake & Shake ist ein Functional Nutrition & Biohacking Hub, der die gesamte biologische Unterstützung liefert, die dein Körper braucht — vom Fokus vor dem Training über die Hydration während der Einheit bis zu Muskelaufbau und Nachtschlaf — ",
      hi: "in nur 25 Sekunden",
      b: ", frisch und in perfekter Konsistenz.",
    },
    recipes: {
      label: "Rezepturen",
      title: "Funktionelle Rezepte",
      sub: "Wir bündeln alle biologischen und Makro-Supplements, die dein Körper rund um die Uhr braucht, in einem einzigen Hub.",
      macrosTitle: "Makros & Basiszutaten",
      functionalTitle: "Funktionelle Booster",
      macros: ["Whey Protein", "Veganes Protein", "EAA (9 essenzielle Aminosäuren)", "Kreatin-Monohydrat", "Kohlenhydrate (Glykogen)", "Glycerol"],
      functional: ["Magnesiumglycinat", "Kollagen-Peptide", "Rote-Bete-Nitrat", "Tart Cherry", "Präbiotikum (PHGG)", "ZMA", "L-Theanin", "Apigenin", "Koffein", "Tyrosin", "Vitamin C", "Ingwer", "Wheatgrass"],
      h1: "Einzigartige Rezepte für jeden Bereich!",
      b1: "Wir entwerfen Rezepte, die auf das Mitgliederprofil und das Konzept deines Studios zugeschnitten sind.",
      h2: "Individuell anpassbare Rezepte!",
      b2: "Mitglieder wählen ihre eigenen Makro- und Supplement-Dosen — und kreieren ihren Shake & Shake, passend zu ihrem Ziel und ihrem Bedürfnis im Moment.",
    },
    hardware: {
      label: "Industriedesign",
      title: "Hardware & Infrastruktur",
      sub: "Spiegelchrom-Gehäuse, Lavendel-Neonbeleuchtung und vollautonomes Innenleben. Eine Design-Ikone, die deinem Studio Prestige verleiht.",
      specsTitle: "Technische Daten",
      alt: "Shake & Shake Automat",
      hotspots: {
        screen: { title: "32” Smart-HD-Touchscreen", desc: "Eine benutzerfreundliche, intuitive und schnelle Oberfläche." },
        payment: { title: "100% kontaktloses Bezahlen", desc: "QR-Code-, Kreditkarten- und Mobile-Payment-Integration." },
        dosing: { title: "Hohe Kapazität & präzise Dosierung", desc: "Mehrere Pulver- und Flüssigkeitstanks für frisches, klumpenfreies Mischen ohne Gramm-Abweichung." },
        clean: { title: "Auto-Clean-Technologie", desc: "Geschlossene automatische Sterilisation mit heißem Wasser nach jedem Getränk." },
      },
      specs: [
        ["Bildschirm", "32” Smart-HD-Touchscreen"],
        ["Tiefe", "900 mm"],
        ["Höhe", "1950 mm"],
        ["Breite", "1100 mm"],
        ["Gewicht", "400 kg"],
        ["Leistung", "AC 220–240V / 50Hz (Standard-Haushalts-/Bürosteckdose)"],
      ],
      compact: {
        title: "Kompaktmodell",
        alt: "Shake & Shake Kompaktautomat",
        hotspots: {
          screen: { title: "18” Smart-HD-Touchscreen", desc: "Eine benutzerfreundliche, intuitive und schnelle Oberfläche." },
          payment: { title: "100% kontaktloses Bezahlen", desc: "" },
          dosing: { title: "Hohe Kapazität & präzise Dosierung", desc: "" },
          clean: { title: "Auto-Clean-Technologie", desc: "" },
        },
        specs: [
          ["Bildschirm", "18” Smart-HD-Touchscreen"],
          ["Tiefe", "580 mm"],
          ["Höhe", "520 mm"],
          ["Breite", "700 mm"],
          ["Gewicht", "43 kg"],
          ["Leistung", "1800 W (Standard-Haushalts-/Bürosteckdose)"],
        ],
      },
    },
    value: {
      label: "Nutzenbilanz",
      title: "Warum Shake & Shake?",
      sub: "Verwandle deinen ungenutzten Quadratmeter in den prestigeträchtigsten Ort deines Studios.",
      groups: [
        { title: "Mitgliederbindung", desc: "Stärke die Bindung, indem Mitglieder ihren gesamten Supplement- und Ernährungsbedarf decken, ohne das Studio zu verlassen." },
        { title: "Prestige & Differenzierung", desc: "Biete das Biohacking & Nutrition Hub Konzept in deinem Studio an." },
        { title: "Null Betriebsaufwand", desc: "Bestandsverfolgung, Nachfüllen, Reinigung, Hygiene und technische Wartung übernimmt vollständig das Shake & Shake Team." },
      ],
    },
    comparison: {
      label: "Zusammenarbeitsmodell",
      title: "Wie wir arbeiten",
      sub: "Keine komplexen Prozesse. Du zeigst uns nur die Fläche, wir erledigen den Rest.",
      weBadge: "Unsere Verantwortung",
      weTitle: "Was wir liefern",
      we: ["Kostenlose Geräteinstallation", "Bestandsverfolgung", "24/7 technischer Service", "Studiospezifische Event-Sponsorings", "Gemeinsame Marketing-Unterstützung"],
      youBadge: "Dein Teil",
      youTitle: "Was wir von dir erwarten",
      you: ["Nur 1 Quadratmeter gut sichtbare Fläche in deinem Studio", "Eine Standard-Steckdose"],
      note: "Das ist alles. Alles nach der Installation liegt komplett bei uns.",
    },
    form: {
      label: "Kontakt",
      title: "Anfrage senden",
      a: "Lass uns dein Studio von einem Ort, an dem man nur trainiert, in ein ganzheitliches ",
      hi: "„Functional Living & Performance Center“",
      b: " verwandeln. Kontaktiere uns für mehr Informationen!",
      fields: {
        full_name: { label: "Vollständiger Name", ph: "Max Mustermann" },
        gym_name: { label: "Studio-Name", ph: "Titanium Fitness Club" },
        city: { label: "Stadt / Bezirk", ph: "München / Bogenhausen" },
        phone: { label: "Telefon", ph: "+49 170 000 00 00" },
        email: { label: "E-Mail", ph: "max@studio.com" },
      },
      submit: "Anfrage senden",
      sending: "Wird gesendet...",
      success: "Deine Anfrage ist eingegangen! Unser Team meldet sich innerhalb von 24 Stunden.",
      error: "Deine Anfrage konnte nicht gesendet werden. Bitte prüfe deine Angaben und versuche es erneut.",
    },
    footer: {
      company: "Firmeninformationen",
      privacy: "Datenschutzhinweise",
      copyright: "Alle Rechte vorbehalten © 2026 Shake & Shake — Functional Nutrition & Biohacking Hub",
    },
    legal: { home: "Startseite" },
    company: {
      title: "Firmeninformationen",
      intro: "shakeandshake.com wird von folgendem Unternehmen bereitgestellt:",
      address: "Adresse: Sachsenhäuser Landwehrweg 159A, 60599, Frankfurt, Deutschland",
      emailLabel: "E-Mail:",
      boardTitle: "Vorstand",
      board: ["Esma Kaya", "Yağmur Yüksel"],
      bankTitle: "Bankverbindung",
      bank: ["Lussho GmbH", "IBAN: DE07100101230684488872", "BIC: QNTODEB2XXX"],
      regTitle: "Handelsregister",
      reg: ["Registergericht: Handelsgericht Frankfurt", "Handelsregisternummer: HRB 136122", "Steuernummer: 014 238 30217"],
      legalTitle: "Rechtliche Hinweise",
      legal1: "Zugangslink zur Online-Streitbeilegungsplattform der Europäischen Kommission (OS-Plattform):",
      odr: "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage",
      legal2: "(Geteilt gemäß der Verordnung über die Online-Beilegung von Verbraucherstreitigkeiten.)",
      legal3: "Wir sind nicht verpflichtet, an einem Verbraucherschlichtungsverfahren teilzunehmen, und geben diesbezüglich keine Zusage ab.",
    },
    kvkk: {
      title: "Datenschutzhinweise",
      updated: "shakeandshake.com — zuletzt aktualisiert: 5. September 2026",
      blocks: [
        {
          title: "Verantwortlicher",
          paras: [
            "Diese Website wird von der Lussho GmbH betrieben. Adresse: Sachsenhäuser Landwehrweg 159A, 60599 Frankfurt, Deutschland E-Mail: info@shakeandshake.com",
            "Für Datenschutzfragen verwenden Sie bitte dieselbe Adresse. Es wurde kein obligatorischer Datenschutzbeauftragter (DSB) bestellt; sollte einer bestellt werden, wird dies auf dieser Seite veröffentlicht.",
          ],
        },
        {
          title: "Geltungsbereich dieses Textes",
          paras: ["Dieser Text gilt für personenbezogene Daten, die beim Besuch von shakeandshake.com, über das Kontaktformular und bei B2B-/Demo-Anfragen verarbeitet werden. Die Bezahlung am Automaten und die Shake-Mitgliederprofile sind ein eigener Prozess des Studiobetreibers; dieser Datenfluss wird durch eine separate Vereinbarung geregelt."],
        },
        {
          title: "Welche Daten",
          list: [
            "Name, Vorname, Unternehmen, E-Mail, Telefon und Nachricht, die Sie im Kontaktformular angeben",
            "Server-Logs: IP-Adresse, Browser, Datum/Uhrzeit, angeforderte Seite",
            "Cookies: nur technisch notwendige (Sitzung). Falls wir Marketing- oder Analyse-Cookies einsetzen, wird dieser Abschnitt aktualisiert.",
            "Soziale Medien: Wenn Sie auf einen Link wie Instagram klicken, gilt die Richtlinie der jeweiligen Plattform.",
          ],
        },
        {
          title: "Zweck und Rechtsgrundlage (DSGVO Art. 6)",
          list: [
            "Bereitstellung der Website und Gewährleistung der Sicherheit — berechtigtes Interesse",
            "Beantwortung einer Demo-/Kooperationsanfrage — vorvertragliche Maßnahmen oder berechtigtes Interesse",
            "Gesetzliche Pflichten (Buchhaltung, behördliche Anfragen)",
            "Marketing-E-Mails nur mit Ihrer ausdrücklichen Einwilligung",
          ],
        },
        {
          title: "Speicherdauer",
          list: [
            "Kontaktanfragen: bis zur Bearbeitung und einer angemessenen Nachfassfrist, in der Regel maximal 24 Monate",
            "Rechnungen / Geschäftskorrespondenz: deutsche Handels- und Steuerfristen (in der Regel 6–10 Jahre)",
            "Server-Logs: kurzfristig, nur so lange wie für die Sicherheit erforderlich",
          ],
        },
        {
          title: "Übermittlung",
          paras: ["Daten können an Dienstleister (Hosting, E-Mail) übermittelt werden, um Anfragen zu beantworten und die Website zu hosten. Bei einer Übermittlung in die USA oder außerhalb des EWR werden geeignete Garantien verwendet. An Behörden werden Daten nur bei gesetzlicher Verpflichtung übermittelt. Wir verkaufen keine Daten."],
        },
        {
          title: "Ihre Rechte (DSGVO Art. 15–21)",
          paras: ["Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerspruch, Widerruf der Einwilligung. Kontakt: info@shakeandshake.com Beschwerde: Hessischer Beauftragte für Datenschutz und Informationsfreiheit (HBDI), Deutschland. Wenn Sie in der Türkei wohnen, können Sie sich auch an die türkische Datenschutzbehörde (KVKK) wenden."],
        },
        {
          title: "Cookies",
          paras: ["Technisch notwendige Cookies halten die Website am Laufen. Falls wir optionale Cookies hinzufügen, wird ein Einwilligungsbanner verwendet."],
        },
        {
          title: "Sicherheit",
          paras: ["HTTPS sowie angemessene technische und organisatorische Maßnahmen werden angewendet. Absolute Sicherheit wird nicht zugesichert."],
        },
        {
          title: "Änderungen",
          paras: ["Dieser Text kann aktualisiert werden. Das Gültigkeitsdatum steht oben auf der Seite."],
        },
      ],
    },
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("ss-lang") || "tr";
    } catch {
      return "tr";
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem("ss-lang", lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: T[lang] }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
